import React from "react";
import { PropTypes } from "prop-types";
import SignatureCanvas from "react-signature-canvas";
import Button from "../Button/Button";
import {
  StyledSignatureContainer,
  StyledSignModal,
} from "./SignatureModal.styled";

const SignatureModal = ({
  isMobile,
  showSignModal,
  onClose,
  onSave,
  clearMessage,
  continueMessage,
}) => {
  const [isSigned, setIsSigned] = React.useState(null);

  const signPad = React.useRef();

  const handleClear = () => {
    signPad.current.clear();
  };
  const handleSave = () => {
    onSave(signPad.current.getTrimmedCanvas().toDataURL("jpeg"));
  };

  const handleClose = () => {
    onClose();
  };

  return (
    showSignModal && (
      <StyledSignModal isMobile={isMobile} onClose={handleClose}>
        <StyledSignatureContainer>
          <SignatureCanvas
            canvasProps={{
              width: isMobile ? 324 : 606,
              height: isMobile ? 211 : 274,
            }}
            ref={signPad}
            onBegin={() => setIsSigned(true)}
          />
        </StyledSignatureContainer>
        <Button
          noLink
          nextButtonDisabled={!isSigned}
          isMobile={isMobile}
          backButtonText={clearMessage}
          continueButtonText={continueMessage}
          onNextClick={handleSave}
          onBackClick={handleClear}
          hideNextButtonIcon
        />
      </StyledSignModal>
    )
  );
};

SignatureModal.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  showSignModal: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  clearMessage: PropTypes.string.isRequired,
  continueMessage: PropTypes.string.isRequired,
};

export default SignatureModal;
